<!-- couponSelect -->
<template>
  <van-popup class="couponSelect" v-model="show" position="bottom" @close="close">
    <div class="couponSelectTitleWrapper">
      <p class="selectCoupon">选择优惠券</p>
      <i class="closeButton" @click="close"></i>
    </div>
    <div v-if="!couponAllList.length" class="noCoupon">
      <i class="couponEmpty"></i>
      <p class="couponEmptyText">暂无优惠券</p>
    </div>
    <div class="hasCoupon" v-else>
      <p :class="['noUse', { noUseActive: noUse || !couponAllList.length }]" @click="noUseCoupon">
        不使用优惠券
      </p>
      <div class="listWrapper">
        <ul class="couponList">
          <li v-for="(couponInfo, index) in couponList" :key="index" class="couponCardWrapper">
            <coupon-card
              :valid="true"
              @couponSelect="couponSelect"
              :couponInfo="couponInfo"
              :orderType="true"
            >
              <span v-if="couponInfo.couponId === recommendInfo.recommend" class="isRecommend">推荐</span>
            </coupon-card>
          </li>
        </ul>
        <p v-if="couponInvalidList.length" class="cantUse">不可用优惠券</p>
        <ul class="couponList">
          <li v-for="(couponInfo, index) in couponInvalidList" :key="index" class="couponCardWrapper">
            <coupon-card :valid="false" :couponInfo="couponInfo" :orderType="true" />
          </li>
        </ul>
      </div>
    </div>
  </van-popup>
</template>

<script>
import moment from 'moment';
import CouponCard from '../../../components/coupon/CouponCard.vue';

export default {
  props: {
    couponSelectShow: {
      type: Boolean,
      default: false,
    },
    couponAllList: {
      type: Array,
      default: () => [],
    },
    recommendInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CouponCard,
  },
  data() {
    return {
      show: false,
      noUse: false,
      couponList: [],
      couponInvalidList: [],
    };
  },
  computed: {
    currentTime() {
      return this.$store.state.currentTime;
    },
  },
  watch: {
    couponAllList: {
      handler(couponList) {
        this.couponList = couponList.filter((coupon) => Number(coupon.available) === 1);
        this.couponInvalidList = couponList.filter((coupon) => !(Number(coupon.available) === 1));
        this.noUse = !!this.couponList.find((coupon) => coupon.active);
      },
      immediate: true,
    },
    couponSelectShow(showStatus) {
      this.show = showStatus;
    },
    currentTime(val) {
      this.couponList.forEach((coupon) => {
        const leftSeconds = Math.floor((coupon.expireTimestamp - val) / 1000);
        const dayDuration = 3600 * 24;
        const leftDays = leftSeconds / dayDuration;
        if (leftDays > 7) {
          Object.assign(coupon, {
            dateTimeInfo: `${moment(coupon.expireTimestamp).format('YYYY-MM-DD hh:mm:ss')}到期`,
          });
        } else if (leftDays > 1) {
          Object.assign(coupon, {
            dateTimeInfo: `还剩${Math.floor(leftDays)}天到期`,
          });
        } else if (leftDays > 0) {
          const hourDuration = 3600;
          const minuteDuration = 60;
          const countdownHours = Math.floor(leftSeconds / hourDuration);
          const countdownMinutes = Math.floor((leftSeconds % hourDuration) / minuteDuration);
          const countdownSeconds = leftSeconds % minuteDuration;
          const hoursText = countdownHours > 0 ? `${countdownHours}:` : '';
          const minutesText = hoursText || countdownMinutes > 0 ? `${countdownMinutes}:` : '';
          Object.assign(coupon, {
            dateTimeInfo: `到期倒计时：${hoursText}${minutesText}${countdownSeconds}`,
          });
        }
      });
    },
  },
  mounted() {
    this.noUse = this.couponList.every((couponInfo) => !couponInfo.active);
  },
  methods: {
    close() {
      this.$emit('close', this.couponList.find((coupon) => coupon.active) || {});
    },
    couponSelect(couponInfo) {
      this.noUse = false;
      this.$emit('couponSelect', couponInfo);
    },
    noUseCoupon() {
      this.noUse = true;
      this.$emit('couponSelect', null);
    },
  },
};
</script>

<style lang="scss">
.couponSelect {
  display: flex;
  flex-direction: column;
  height: 50%;
  max-height: 87.492%;
  padding: 29px 36px;
  overflow: hidden;
  border-radius: 14px 14px 0 0;
}

.selectCoupon {
  height: 40px;
  margin-bottom: 33px;
  color: #333;
  font-weight: bold;
  font-size: 29px;
  line-height: 40px;
  text-align: center;
}

.closeButton {
  position: absolute;
  top: 38px;
  right: 38px;
  width: 26px;
  height: 26px;
  background: url('../../../assets/img/payment/dialog_close.png') no-repeat center;
  background-size: contain;
  cursor: pointer;
}

.noCoupon, .hasCoupon {
  flex: 1;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;

   /* background-color:transparent; */
  }
}

.noCoupon {
  .couponEmpty {
    display: block;
    width: 290px;
    height: 290px;
    margin: 66px auto 0;
    background: url('../../../assets/img/payment/coupon_empty.png') no-repeat center;
    background-size: contain;
  }

  .couponEmptyText {
    height: 31px;
    color: #A5A5A5;
    font-weight: 500;
    font-size: 22px;
    line-height: 31px;
    text-align: center;
  }
}

.noUse {
  height: 36px;
  padding-left: 42px;
  color: #787878;
  font-size: 25px;
  line-height: 36px;
  background: url('../../../assets/img/payment/unselect.png') no-repeat left center;
  background-size: contain;
  cursor: pointer;

  &.noUseActive {
    background-image: url('../../../assets/img/payment/selected.png');
  }
}

.listWrapper {
  flex: 1;
  overflow: hidden;

  .couponList {
    padding: 29px 0 0;

    .couponCardWrapper {
      margin-bottom: 29px;
    }

    .isRecommend {
      position: absolute;
      top: 0;
      right: 0;
      width: 58px;
      height: 33px;
      color: #fff;
      font-size: 22px;
      line-height: 33px;
      text-align: center;
      background: #ff6c02;
      border-radius: 0 5px 0 5px;
    }
  }

  .cantUse {
    height: 36px;
    color: #333;
    font-weight: 500;
    font-size: 25px;
    line-height: 36px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
